import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { createAttendance } from "../../../axios/Eventlog/EventLogApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import { useAuth } from "../../../context/AuthContext";

const ConfirmCheckInOutDialog = ({ onClose }) => {
  const { profile, genaralExpiredTime } = useAuth();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const getExpiredTimeText = () => {
    const now = new Date();
    const expiredTime = new Date(now.getTime() + genaralExpiredTime * 1000);
    const hours = expiredTime.getHours().toString().padStart(2, "0");
    const minutes = expiredTime.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const getTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  const handleClick = async () => {
    if (!profile.userId) return;

    setLoading(true);
    try {
      await createAttendance(
        profile.userId,
        localStorage.getItem("i18nextLngId"),
        getTimeZone()
      );
      toast.success(
        <Trans
          i18nKey="common.content-108"
          values={{ expiredTime: getExpiredTimeText() }}
        />
      );
      onClose(true);
    } catch (err) {
      console.log("err: ", err);
      if (err.response) {
        if (err.response.status !== 500) {
          toast.error(err.response.data.message);
        } else {
          toast.error(t("common.content-109"));
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="warning"
      title={t("common.confirm-check-in-out")}
      subtitle={
        <Trans
          i18nKey="common.are-you-sure-you-want-to-create-a-request-check-in-out"
          values={{
            minutes: Math.round(Number(genaralExpiredTime) / 60) || 0,
            expiredTime: getExpiredTimeText(),
          }}
        />
      }
      confirmText={t("button.confirm")}
      cancelText={t("button.close")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleClick}
    />
  );
};

export default ConfirmCheckInOutDialog;
